import { useState } from "react";
import { MailWarning } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";

export const EmailBanner = () => {
    const { user } = useAuth();
    const [status, setStatus] = useState({ text: "", ok: true });
    const [busy, setBusy] = useState(false);
    if (!user || user.role !== "azienda" || user.email_confirmed) return null;

    const resend = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/auth/resend-confirmation");
            setStatus({ text: data.message, ok: true });
        } catch (err) {
            setStatus({ text: errorMessage(err), ok: false });
        } finally {
            setBusy(false);
        }
    };

    return (
        <section aria-label="Conferma email" className="bg-edi-warning-bg text-edi-warning-text border-b-2 border-edi-lime" data-testid="email-confirm-banner">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 py-3 flex flex-wrap items-center gap-3">
                <MailWarning aria-hidden="true" size={20} />
                <p className="font-medium flex-1 min-w-[12rem]">Conferma la tua email per completare la registrazione</p>
                <button type="button" className="btn-secondary py-2" onClick={resend} disabled={busy} data-testid="email-resend-button">
                    Invia di nuovo
                </button>
                <p role="status" aria-live="polite" className="w-full sm:w-auto font-semibold" data-testid="email-resend-status">
                    {status.text}
                </p>
            </div>
        </section>
    );
};
